import lunr from "/home/webb/WebstormProjects/file-manager-docs/node_modules/lunr/lunr.js";
require("/home/webb/WebstormProjects/file-manager-docs/node_modules/lunr-languages/lunr.stemmer.support.js")(lunr);
require("/home/webb/WebstormProjects/file-manager-docs/node_modules/@easyops-cn/docusaurus-search-local/dist/client/shared/lunrLanguageZh.js").lunrLanguageZh(lunr);
require("/home/webb/WebstormProjects/file-manager-docs/node_modules/lunr-languages/lunr.multi.js")(lunr);
export const removeDefaultStopWordFilter = [];
export const language = ["en","zh"];
export const searchIndexUrl = "search-index{dir}-965f1508.json";
export const searchResultLimits = 8;
export const fuzzyMatchingDistance = 1;